<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => toggleSidebar(val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ titleForm }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Valor"
            rules="required"
          >
            <b-row
              v-show="formHijo"
              class="row text-center"
            >
              <b-col
                sm="12"
              >
                <p> OPCIÓN: {{ subTitleForm }}</p>
              </b-col>
            </b-row>
            <b-form-group>
              <label for="valor">Valor </label>
              <small class="text-muted">
                <i
                  class="popover-space"
                >
                  <feather-icon
                    id="popover-valor"
                    icon="InfoIcon"
                    class="mr-50 fa-red"
                    @click="hidePopover"
                  />
                </i>
              </small>
              <b-form-input
                id="valor"
                v-model="formData.valor"
                :state="getValidationState(validationContext)"
                trim
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-popover
            target="popover-valor"
            placement="top"
            triggers="hover"
          >
            <template #title>
              Definición de Valor
            </template>
            <span>
              Representa el valor que será guardado en una respuesta
            </span>
          </b-popover>
          <validation-provider
            #default="validationContext"
            name="Label"
            rules="required"
          >
            <b-form-group>
              <label for="label">Label </label>
              <small class="text-muted">
                <i
                  class="popover-space"
                >
                  <feather-icon
                    id="popover-label"
                    icon="InfoIcon"
                    class="mr-50 fa-red"
                    @click="hidePopover"
                  />
                </i>
              </small>
              <b-form-input
                id="label"
                v-model="formData.label"
                :state="getValidationState(validationContext)"
                trim
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-popover
            target="popover-label"
            placement="top"
            triggers="hover"
          >
            <template #title>
              Definición de Label
            </template>
            <span>
              Representa el texto que se mostrará en el aplicativo movil
            </span>
          </b-popover>
          <validation-provider
            #default="validationContext"
            name="GrupoOpcion"
            rules="required"
          >
            <b-form-group
              label="Grupo Opción"
              label-for="grupoOpcion"
            >
              <v-select
                v-model="grupoOpcion"
                :reduce="m => m.idGrupoOpcion"
                label="descripcion"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionGrupoOpcion"
                input-id="descripcion"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-form-group
            v-show="false"
          >
            <label for="metadata">Metadata </label>
            <small class="text-muted">
              <i
                class="popover-space"
              >
                <feather-icon
                  id="popover-metadata"
                  icon="InfoIcon"
                  class="mr-50 fa-red"
                  @click="hidePopover"
                />
              </i>
            </small>
            <b-form-input
              id="metadata"
              v-model="formData.metadata"
              trim
            />
          </b-form-group>
          <b-popover
            target="popover-metadata"
            placement="top"
            triggers="hover"
          >
            <template #title>
              Definición de Metadata
            </template>
            <span>
              La metadata representa la adición de más datos de una opción
            </span>
          </b-popover>
          <b-form-group
            label-for="requiereDescripcion"
          >
            <b-form-checkbox
              v-model="requiereDescripcion"
            >
              ¿ Requiere Descripción ?
            </b-form-checkbox>
          </b-form-group>
          <validation-provider
            #default="validationContext"
            name="Orden"
            rules="required"
          >
            <b-form-group
              label="Orden"
              label-for="orden"
              type="number"
            >
              <b-form-input
                id="demo-sb"
                v-model="orden"
                min="1"
                max="10000"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              :disabled="isBusy"
            >
              Guardar
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormCheckbox, VBPopover, BPopover, BRow, BCol,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { useNotify } from '@/helpers/toast'
import vSelect from 'vue-select'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    BPopover,
    BRow,
    BCol,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    dataEdit: {
      type: Object,
      required: false,
      default: null,
    },
    order: {
      type: Number,
      require: true,
      default: 1,
    },
    formType: {
      type: String,
      required: true,
    },
    padre: {
      type: Number,
      required: true,
    },
    selectGrupopcion: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      required,
    }
  },
  setup(props, context) {
    const { notify } = useNotify(context)
    const showPopover = () => {
      context.emit('bv::show::popover', 'popover-valor')
    }
    const hidePopover = () => {
      context.emit('bv::hide::popover', 'popover-button-2')
    }
    const titleForm = ref('')
    const optionGrupoOpcion = ref([])
    const blankData = {
      valor: '',
      label: '',
      metadata: '',
      orden: 1,
      requiereDescripcion: false,
    }
    const blanckGrupoOpcion = 0
    const blanckRequiereDescripcion = ''
    const blanckOrden = ''
    const formHijo = ref(false)
    const grupoOpcion = ref('')
    const orden = ref(props.order)
    const requiereDescripcion = ref(false)
    const isBusy = ref(false)
    const subTitleForm = ref('')

    const formData = ref(JSON.parse(JSON.stringify(blankData)))/* desestructuracion de  blankData */
    const resetData = () => {
      formData.value = JSON.parse(JSON.stringify(blankData))
      orden.value = JSON.parse(JSON.stringify(blanckOrden))
      grupoOpcion.value = JSON.parse(JSON.stringify(blanckGrupoOpcion))
      requiereDescripcion.value = JSON.parse(JSON.stringify(blanckRequiereDescripcion))
    }

    const onSubmit = () => {
      isBusy.value = true
      let service = 'gsencuesta/OPCION_CREATE'
      if (props.formType === 'edit' && props.padre === 0) {
        service = 'gsencuesta/OPCION_UPDATE'
      }
      formData.value.orden = orden.value
      formData.value.grupoOpcion = {
        idGrupoOpcion: grupoOpcion.value,
      }
      formData.value.requiereDescripcion = requiereDescripcion.value
      store.dispatch(service, formData.value)
        .then(response => {
          isBusy.value = false
          context.emit('refetch-data', response)
          context.emit('update:is-add-new-user-sidebar-active', false)
        })
        .catch(error => {
          isBusy.value = false
          // emit('error-data', error)
          notify('Ha ocurrido un error', error.response.data.message, 'danger')
          // emit('update:is-add-new-user-sidebar-active', false)
        })
    }
    const dataForm = () => {
      orden.value = 1
      requiereDescripcion.value = false
      grupoOpcion.value = 0
      store
        .dispatch('gsencuesta/GRUPO_OPCION_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          sortBy: '',
        })
        .then(response => {
          if (response !== undefined) {
            optionGrupoOpcion.value = response
            grupoOpcion.value = props.selectGrupopcion.idGrupoOpcion
          }
        })
        .catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
    }

    const toggleSidebar = val => {
      dataForm()
      context.emit('update:is-add-new-user-sidebar-active', val)
      if (props.formType === 'new') {
        titleForm.value = 'Agregar Opción'
        resetData()
      }
      orden.value = props.order + 1
      requiereDescripcion.value = false
      if (props.formType === 'edit') {
        if (props.padre === 0) {
          formData.value = {
            idOpcion: props.dataEdit.idOpcion,
            valor: props.dataEdit.valor,
            label: props.dataEdit.label,
            metadata: props.dataEdit.metadata,
            padre: props.dataEdit.padre,
          }
          orden.value = props.dataEdit.orden
          grupoOpcion.value = props.dataEdit.grupoOpcion.idGrupoOpcion
          requiereDescripcion.value = props.dataEdit.requiereDescripcion
          titleForm.value = 'Editar Opción'
          if (props.dataEdit.padre !== 0) {
            titleForm.value = 'Editar Hijo'
            subTitleForm.value = props.dataEdit.label
          }
          formHijo.value = false
        } else {
          formData.value = {
            idOpcion: 0,
            valor: '',
            label: '',
            metadata: '',
            padre: (props.padre === 0) ? 0 : props.dataEdit.idOpcion,
          }
          subTitleForm.value = props.dataEdit.label
          formHijo.value = true
          titleForm.value = 'Agregar Nuevo Hijo'
        }
      } else {
        formData.value = {
          idOpcion: 0,
          valor: '',
          label: '',
          metadata: '',
          padre: 0,
        }
        formHijo.value = false
        subTitleForm.value = ''
      }
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)

    return {
      formData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      grupoOpcion,
      requiereDescripcion,
      orden,
      toggleSidebar,
      titleForm,
      optionGrupoOpcion,
      showPopover,
      hidePopover,
      isBusy,
      formHijo,
      subTitleForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
